<button
  *ngIf="showCompareButton"
  class="compare-button"
  [ngClass]="{
    'big-compare-button cta-font-style': isBig,
    'is-small': isSmall,
    'voice-page': isVoicePage
  }"
  (click)="onButtonClick()"
>
  {{ copy[jsonKey.NAVIGATION_COMPARE] }}
</button>
